import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgArrowUpGraph = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-.5 -.5 16 16"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    Arrow Up Graph Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M14.2629 14.2629H.737V.737"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M13.6726 2.5016 7.7951 8.3853 5.4404 6.0306.737 10.734"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M10.7339 2.5016h2.9387v2.9388"
    />
  </svg>
);
export default SvgArrowUpGraph;
